import React, { useEffect, useState } from 'react';
import { Menu, X, Atom } from 'lucide-react';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (id: string) => {
    setIsMobileMenuOpen(false);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const navLinks = [{
    name: 'Concepts',
    id: 'concepts'
  }, {
    name: 'Manifesto',
    id: 'manifesto'
  }, {
    name: 'Getting Started',
    id: 'getting-started'
  }, {
    name: 'Platform',
    id: 'platform'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-background/80 backdrop-blur-md shadow-sm border-b' : 'bg-transparent'}`} data-id="element-271">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-272">
        <div className="flex items-center justify-between h-16 md:h-20" data-id="element-273">
          {/* Logo */}
          <button onClick={() => scrollToSection('hero')} className="flex items-center space-x-2 text-primary font-bold text-xl tracking-tight" data-id="element-274">
            <Atom className="h-8 w-8 text-indigo-600" data-id="element-275" />
            <span data-id="element-276">Atomic Team Design</span>
          </button>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-277">
            {navLinks.map(link => <button key={link.name} onClick={() => scrollToSection(link.id)} className="text-sm font-medium text-muted-foreground hover:text-primary transition-colors" data-id="element-278">
                {link.name}
              </button>)}
            <button onClick={() => scrollToSection('waitlist')} className="bg-primary text-primary-foreground px-5 py-2 rounded-lg text-sm font-medium hover:opacity-90 transition-opacity" data-id="element-279">
              Join Waitlist
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button className="md:hidden p-2 text-primary" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-280">
            {isMobileMenuOpen ? <X className="h-6 w-6" data-id="element-281" /> : <Menu className="h-6 w-6" data-id="element-282" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu Drawer */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-background border-b shadow-lg p-4 flex flex-col space-y-4 animate-in slide-in-from-top-5" data-id="element-283">
          {navLinks.map(link => <button key={link.name} onClick={() => scrollToSection(link.id)} className="text-left px-4 py-2 text-base font-medium text-muted-foreground hover:text-primary hover:bg-muted/50 rounded-md transition-colors" data-id="element-284">
              {link.name}
            </button>)}
          <button onClick={() => scrollToSection('waitlist')} className="w-full bg-primary text-primary-foreground px-5 py-3 rounded-lg text-base font-medium hover:opacity-90 transition-opacity mt-2" data-id="element-285">
            Join Waitlist
          </button>
        </div>}
    </nav>;
}